/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Delete_Event_CancelInputs */



/**
* | output |
* | --- |
* | "No" |
*
* @param {Shortcut_Keys_Delete_Event_CancelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_delete_event_cancel = /** @type {((inputs?: Shortcut_Keys_Delete_Event_CancelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Delete_Event_CancelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non")
	if (locale === "de") return /** @type {LocalizedString} */ ("NEIN")
	if (locale === "it") return /** @type {LocalizedString} */ ("NO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нет")
	if (locale === "es") return /** @type {LocalizedString} */ ("No")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("不")
	if (locale === "ja") return /** @type {LocalizedString} */ ("いいえ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não")
	return /** @type {LocalizedString} */ ("No")
});